import visionCallService from "./visionCallService";
import { visionURL } from "../config/environment";

export const stopImpersonate = id => {
  visionCallService.deleteRequest(
    `${visionURL}/learning_center/api/impersonations/${id}`,
    function(data) {
      window.location = `${visionURL}${data.redirect_url}`;
    },
    function(error) {
      console.log(error);
    }
  );
};
